import { UNIT_TYPES } from 'constants/unitTypes';
import { convert } from 'util/unitConversion';
import { getLocaleUnitSymbol } from 'util/unit';

export function calculateApplicationArea(fieldArea, championArea) {
  let fieldSize = fieldArea.q;
  const fieldUnit = fieldArea.u;
  let championSize = championArea.value;
  const championUnit = championArea.unit;
  const localUnit = getLocaleUnitSymbol('area');
  
  if (fieldUnit !== localUnit) {
    fieldSize = convert({
      from: { q: fieldSize, u: UNIT_TYPES[fieldUnit] },
      to: { u: UNIT_TYPES[localUnit] }
    }).q;
  }

  if (championUnit !== localUnit) {
    championSize = convert({
      from: { q: championSize, u: UNIT_TYPES[championUnit] },
      to: { u: UNIT_TYPES[localUnit] }
    }).q;
  }

  return { q: fieldSize - championSize, u: UNIT_TYPES[localUnit] };
}
